import { IRaffleBlacklist } from '../../../interfaces';

class RaffleBlacklistMapper {
    toPersistence(domainBlacklist: IRaffleBlacklist): any {
        return {
            cpfCnpj: domainBlacklist.cpfCnpj,
            name: domainBlacklist.name,
        }
    }

    toDomain(persistenceCnpjBlacklist: any): IRaffleBlacklist {
        return {
            id: persistenceCnpjBlacklist.id,
            cpfCnpj: persistenceCnpjBlacklist.cpfCnpj,
            name: persistenceCnpjBlacklist.name,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RaffleBlacklistMapper();
